/* eslint-disable */
const filtroTelefoneBr = {
  install(Vue) {
    Vue.filter('filtroTelefoneBr', (data) => {
      if (data) {
        return '(' + data.substring(0, 2) + ') ' + data.substring(2, 6) + '-' + data.substring(6);
      }
      return 'N/I';
    });
  }
}

export default filtroTelefoneBr;
